import React from 'react'
import DropzoneComponent from 'react-dropzone-component'
import csrf from 'utils/csrf'
import update from 'immutability-helper'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'

import { apiPost } from 'utils/api'

import Photo from './ItemPhotos/Photo'
import Lightbox from './ItemPhotos/Lightbox'

const SLICE = 7

const idFromFile = (file) => [file.name, file.lastModified].join('-=-')

const SortablePhoto = SortableElement(Photo)

const SortableList = SortableContainer(({ photos, files, collapsed, onPhotoClick, canDelete }) => {
  const fileKeys = Object.keys(files)
  let sliced = photos
  if (collapsed) sliced = photos.slice(0, SLICE)

  return (
    <div className='clearfix' onClick={(e) => { e.stopPropagation(); e.preventDefault() }}>
      {sliced.map((photo, index) => (
        <SortablePhoto
          photo={photo}
          key={photo.id}
          index={index}
          canDelete={canDelete}
          onClick={() => onPhotoClick(index)}
        />
      ))}

      {fileKeys.map((key) => <Photo photo={files[key]} key={key} />)}
    </div>
  )
})

export class ItemPhotos extends React.PureComponent {
  state = {
    files: {},
    photos: [],
    collapsed: false,
    lightboxOpen: false,
    canDelete: true,
  }

  componentWillMount () {
    this.setState({
      files: {},
      photos: this.props.photos,
      collapsed: this.props.big,
      lightboxOpen: false,
      canDelete: !this.props.disableDelete,
    })
  }

  djsConfig () {
    return {
      headers: csrf,
      paramName: 'photo[data]',
      previewTemplate: '<span></span>',
      clickable: `#${this.id()} .ui.add.photo`,
    }
  }

  dropzoneConfig () {
    return {
      iconFiletypes: ['.jpg', '.png', '.gif'],
      showFiletypeIcon: false,
      postUrl: this.props.upload_url,
      dropzoneSelector: `#${this.id()}`,
    }
  }

  eventHandlers () {
    return {
      addedfile: (file) => {
        const id = idFromFile(file)
        const newFile = { id, file, delete_url: null, url: null }

        this.setState(update(this.state, {
          files: {
            $merge: {
              [id]: newFile,
            },
          },
          collapsed: { $set: false },
        }))
      },

      thumbnail: (file, dataUrl) => {
        this.setState(update(this.state, {
          files: {
            [idFromFile(file)]: {
              url: {
                $set: dataUrl,
              }
            },
          },
        }))
      },

      success: (file, response) => {
        this.setState(update(this.state, {
          files: {
            $unset: [idFromFile(file)],
          },
          photos: {
            $push: [JSON.parse(response)],
          },
        }))
      },

      error: (file) => {
        this.setState(update(this.state, {
          files: {
            $unset: [idFromFile(file)],
          },
        }))
      },
    }
  }

  id () {
    return `item-photos-${this.props.element_id}`
  }

  className () {
    let classes = ['ui', 'photos']
    if (this.props.big) classes.push('big')
    if (this.props.no_border) classes.push('no-border')
    return classes.join(' ')
  }

  onSortEnd ({ oldIndex, newIndex }) {
    this.setState(update(this.state, {
      photos: {
        $set: arrayMove(this.state.photos, oldIndex, newIndex),
      }
    }), () => this.submitSort())
  }

  submitSort () {
    if (!this.props.sort_url) return
    const ids = this.state.photos.map((photo) => photo.id)
    apiPost(this.props.sort_url, {
      photo: ids,
    })
  }

  expand () {
    this.setState(update(this.state, {
      collapsed: {
        $set: false,
      },
    }))
  }

  showLightbox (index) {
    this.lightbox.open(index)
  }

  render () {
    const { collapsed, photos, lightboxOpen } = this.state
    const showToggle = collapsed && photos.length > SLICE

    return (
      <div className={this.className()} id={this.id()}>
        <SortableList
          axis='xy'
          onSortEnd={(indices) => this.onSortEnd(indices)}
          lockOffset='100%'
          pressDelay={75}
          onPhotoClick={(index) => this.showLightbox(index)}
          canDelete={this.state.canDelete}
          {...this.state}
        />

        <div className='ui add photo' onClick={(e) => e.stopPropagation()}>
          <div className='ui photo-inner'>
            <i className='camera icon' />
          </div>
        </div>

        {showToggle && (
          <p onClick={() => this.expand()}>rozbalit vše</p>
        )}

        <DropzoneComponent
          config={this.dropzoneConfig()}
          eventHandlers={this.eventHandlers()}
          djsConfig={this.djsConfig()}
        />

        <Lightbox
          photos={this.state.photos}
          ref={(c) => { this.lightbox = c }}
        />
      </div>
    )
  }
}

export default ItemPhotos



// WEBPACK FOOTER //
// ./app/javascript/components/ItemPhotos.js